export default "__VITE_ASSET__tlImUf4Y__"